// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-product-from-session-js": () => import("./../../../src/pages/product-from-session.js" /* webpackChunkName: "component---src-pages-product-from-session-js" */)
}

